var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widget-actions" },
    [
      _c(
        "a-dropdown",
        { attrs: { trigger: ["click"] } },
        [
          _c("a-button", { attrs: { type: "link" } }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")]),
          ]),
          _vm._v(" "),
          _c(
            "a-menu",
            {
              staticClass: "widget-actions-menu",
              attrs: { slot: "overlay" },
              slot: "overlay",
            },
            [
              _c(
                "a-menu-item",
                {
                  attrs: { disabled: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("fullscreen")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("fullscreen"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("report.fullScreen")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-menu-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("edit")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("settings"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.settings")))]),
                ]
              ),
              _vm._v(" "),
              _c("a-menu-item", { on: { click: _vm.handleRename } }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("message.rename")))]),
              ]),
              _vm._v(" "),
              _c(
                "a-menu-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("duplicate")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("content_copy"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.duplicate")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-menu-item",
                {
                  attrs: { disabled: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("dock")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("dock")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.pin")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-menu-item",
                {
                  attrs: { disabled: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("export")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("download"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("tables.exports")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-menu-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("delete"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.delete")))]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("tables.renameWidget"),
            confirmLoading: _vm.saving,
          },
          on: { ok: _vm.saveNewName },
          model: {
            value: _vm.showRenameModal,
            callback: function ($$v) {
              _vm.showRenameModal = $$v
            },
            expression: "showRenameModal",
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.widgetName") } },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("tables.widgetName") },
                model: {
                  value: _vm.newName,
                  callback: function ($$v) {
                    _vm.newName = $$v
                  },
                  expression: "newName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }